import {
  CHART_COLORS,
  type TertiaryTab,
} from "../../../../../../../components/app/provider/patient/chart";
import { PRIMITIVE, px } from "../../../../../../../tokens/design-tokens";

export const TABS_DATA: TertiaryTab[] = [
  { value: "", label: "Demographics" },
  { value: "insurance", label: "Insurance" },
  { value: "eligibility", label: "Eligibility" },
  { value: "authorization", label: "Authorization" },
  { value: "portal-access", label: "Portal Access" },
];

// Styling for the Preferences / Emergency Contact DataGrids.
// Matches Figma 3.2.1 Demographics — Preferences & Emergency Contact:
// - Column header: Title/T6/Regular (12px, weight 400), #292929, bg #fff
// - Cell:          Body/5/Regular (12px, weight 400), #292929
// - Row striping:  row 1 white, row 2 #f5f5f5
// - Overlay (no data): matches cell styling
export const DEMO_TABLE_SX = {
  // Higher-specificity selectors (.MuiDataGrid-root .xxx) to beat
  // CustomDataGridV2's internal grey-header default.
  "& .MuiDataGrid-root .MuiDataGrid-columnHeaders, & .MuiDataGrid-root .MuiDataGrid-columnHeader":
    {
      backgroundColor: CHART_COLORS.surfaceWhite,
      borderRadius: 0,
    },
  // Column separator between each header cell (Type | Name | Address | Fax No. | Contact No.)
  // Applies to Preferences and Emergency Contact tables alike.
  "& .MuiDataGrid-root .MuiDataGrid-columnHeader": {
    borderBottom: `1px solid ${CHART_COLORS.border}`,
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontWeight: PRIMITIVE.typography.fontWeight.regular,
    fontSize: px(PRIMITIVE.typography.fontSize.body.b5),
    color: CHART_COLORS.textDark,
  },
  "& .MuiDataGrid-cellContent": {
    fontWeight: PRIMITIVE.typography.fontWeight.regular,
    fontSize: px(PRIMITIVE.typography.fontSize.body.b5),
    color: CHART_COLORS.textDark,
  },
  "& .MuiDataGrid-row:nth-of-type(odd)": {
    backgroundColor: CHART_COLORS.surfaceWhite,
  },
  "& .MuiDataGrid-row:nth-of-type(even)": {
    backgroundColor: CHART_COLORS.surfaceAlt,
  },
  "& .MuiDataGrid-overlay .MuiTypography-root": {
    fontWeight: PRIMITIVE.typography.fontWeight.regular,
    fontSize: px(PRIMITIVE.typography.fontSize.body.b5),
    color: CHART_COLORS.textDark,
  },
};
